import {createRouter, createWebHistory} from '@ionic/vue-router';
import {RouteRecordRaw} from 'vue-router';
import Permission from '@/views/Permission.vue';
import Login from "@/views/Login.vue";
import Home from "@/views/HomePage.vue";
import HeilaSuite from "@/views/HeilaSuite.vue";
import Settings from "@/views/SettingPage.vue";
import ServiceGateway from "@/views/ServiceGateway.vue";
import {useAuth} from '@/composables/useAuth';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/test',
        name: 'Test',
        component: Home
    },
    {
        path: '/permission',
        name: 'Permission',
        component: Permission,
        meta: {requiresAuth: true}
    },
    {
        path: '/settings',
        name: 'Settings',
        component: Settings,
        meta: {requiresAuth: true}
    },
    {
        path: '/service/:serviceId',
        name: 'ServiceIframe',
        component: ServiceGateway,
        meta: {requiresAuth: true}
    },
    {
        path: '/:serviceId?',
        name: 'HeilaSuite',
        component: HeilaSuite,
        props: true,
        meta: {requiresAuth: true}
    }
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    strict: false,
});

// Signals that initAuth() has completed at least once — guards must not
// make auth decisions before this is true or they risk acting on stale state
let authReady = false;

export function markAuthReady() {
    authReady = true;
}

router.beforeEach(async (to, from, next) => {
    const {user, initAuth} = useAuth();

    if (Object.keys(to.query).length > 0) {
        const queryParams = {...to.query};
        return next({
            path: to.path,
            query: {},
            state: {...queryParams},
            replace: true,
        });
    }

    if (!authReady) {
        await initAuth();
        authReady = true;
    }

    const isLoggedIn = !!user.value;
    const publicPages = ['/login', '/test'];
    const authRequired = !publicPages.includes(to.path);

    if (isLoggedIn && publicPages.includes(to.path)) {
        return next('/');
    }

    if (authRequired && !isLoggedIn) {
        return next({
            path: '/login',
            state: {
                redir: to.path.replace('/', ''),
            },
        });
    }

    next();
});

export default router;